import { EventEmitter, Injectable } from '@angular/core';
import { StartUpService } from './start-up-service';
import { UserApi } from './api-service/user/user-api';
import { WebApiClient } from './web-api-client.service';
import { WebApiService } from './web-api.service';
import { DateHelper } from '../shared/helpers/date-helper';
import { HttpHeaders } from '@angular/common/http';
import { MemoryCache } from './memory-cache-service';
import { delay } from '../shared/utilities';
import { HcrService } from './hcr-service.service';
import { BaseConfig } from './base-config.service';

@Injectable({
  providedIn: 'root'
})
export class DebugNotifyService {
  apiService:WebApiService;
  constructor(private apiClient: WebApiClient,
    private mem:MemoryCache,
  ) {
    this.apiService = apiClient.createHisService('system/ApiLog');
  }
  
  lastSpeedTest = 0;
  async SpeedTest():Promise<{uploadSpeed:number,downloadSpeed:number,toServerDelay:number,fromServerDelay:number,roundTripTime:number}>{
    
    console.log('SpeedTest')
    // 超過25秒才重測
    if(Date.now() - this.lastSpeedTest < 20000){
      if(this.mem.has('SpeedTest')){
        return this.mem.get('SpeedTest');
      }else{
        //第二次執行等待首次執行完成再回傳快取結果
        return await new Promise(async (rs,rj)=>{
          var waitTime = 0;
          while(!this.mem.has('SpeedTest') && waitTime<10){
            await delay(1000);
            waitTime++;
          }
          rs(this.mem.get('SpeedTest',''));
        })
      }
    }
    this.lastSpeedTest = Date.now();
    this.apiService.enableLoader = false;
    var payload = new Uint8Array(1024 * 100); // 100KB
    const blob = new Blob([payload], { type: 'application/octet-stream' });

    var t1 = Date.now();
    var ret = await this.apiService.postAdv('UploadTest',blob,false,{
      headers: new HttpHeaders( { 'Content-Type': 'application/octet-stream'})
    }).toPromise<{serverTime:number,payload: string }>()
    var t3 = Date.now();
    const uploadTime = (t3 - t1) / 1000;   // 秒
    const dataSizeKB = payload.length / 1024;
    const uploadSpeed = dataSizeKB / uploadTime;       // KB/s

    t1 = Date.now();
    var ret = await this.apiService.get('DownloadTest',blob,false).toPromise<{serverTime:number,payload: string }>()
    t3 = Date.now();
    const downloadTime = (t3 - t1) / 1000;   // 秒
    const downloadDataSizeKB = ret.payload.length / 1024;
    const downloadSpeed = downloadDataSizeKB / downloadTime;   // KB/s
    
    t1 = Date.now();
    var pingRet = await this.apiService.get('Ping?t='+t1).toPromise<{serverTime:number}>()
    t3 = Date.now();
    var t2 = pingRet.serverTime;
    const roundTripTime = t3 - t1;
    const toServerDelay = t2 - t1;
    const fromServerDelay = t3 - t2;
    
    this.mem.set('SpeedTest',{uploadSpeed,downloadSpeed,toServerDelay,fromServerDelay,roundTripTime});
    return {uploadSpeed,downloadSpeed,toServerDelay,fromServerDelay,roundTripTime}
  }
  Notify(...o:any[]){
    this.apiService.enableLoader = false;
    var m = '';
    o.forEach(x=>{
      var t = JSON.stringify(x); 
      if(x instanceof Error){
        t = x.message+'\n\n'+x.stack
      }
      m+= t+'\n\n';
    })
    
    this.apiService.post('DebugNotify',{
      text: m
    }).subscribe();
  }
}

